import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import _createForOfIteratorHelper from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, packageData } from "@/mixins/index";
import addPackageTask from "./components/addPackageTask";
import packageModuleItem from "./components/packageModuleItem";
import parameterAllDataPopup from "./components/parameterAllDataPopup";
import addDelayTime from "./components/addDelayTime";
import packageModuleItemTask from "./components/packageModuleItemTask";
export default {
  name: "packagingModule",
  mixins: [loadMoreList, packageData],
  components: {
    addPackageTask: addPackageTask,
    packageModuleItem: packageModuleItem,
    parameterAllDataPopup: parameterAllDataPopup,
    packageModuleItemTask: packageModuleItemTask
  },
  data: function data() {
    return {
      pagingReqFn: "subTemplateList",
      delIds: [],
      timer: null,
      timing: [{
        label: '否',
        value: 2
      }, {
        label: '是',
        value: 1
      }],
      delay_time: 0,
      chooseItem: ""
    };
  },
  mounted: function mounted() {},
  activated: function activated() {
    this.getcommonDataNew(['subTemplateList', 'gameGroupList', 'originPkgList', 'originPkgTypeList']);
    this.getList();
  },
  beforeDestroy: function beforeDestroy() {
    this.clearRequestInterval();
  },
  methods: {
    handleSelectionChange: function handleSelectionChange(e) {
      this.delIds = e;
    },
    downLoad: function downLoad(url) {
      window.open(url);
    },
    del: function del(dateList) {
      var _this = this;

      var ids = dateList.map(function (item) {
        return item.id;
      }).toString();
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'subTemplateDel',
        data: {
          id: ids
        }
      }).then(function () {
        _this.getList(_this.paramsData.page);
      });
    },
    getcommonData: function getcommonData() {
      var _arguments = arguments,
          _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var reqList, _iterator, _step, i, res;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                reqList = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : [];
                _iterator = _createForOfIteratorHelper(reqList);
                _context.prev = 2;

                _iterator.s();

              case 4:
                if ((_step = _iterator.n()).done) {
                  _context.next = 12;
                  break;
                }

                i = _step.value;
                _context.next = 8;
                return _this2.$api[i]({
                  pageSize: 1000
                });

              case 8:
                res = _context.sent;
                _this2[i] = res.data.data;

              case 10:
                _context.next = 4;
                break;

              case 12:
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](2);

                _iterator.e(_context.t0);

              case 17:
                _context.prev = 17;

                _iterator.f();

                return _context.finish(17);

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 14, 17, 20]]);
      }))();
    },
    getDelayTime: function getDelayTime(data) {
      this.delay_time = data;
      console.log("this.delay_time", this.delay_time);
      this.confirmPackage();
    },
    pkgStart: function pkgStart(row) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // this.chooseItem = JSON.stringify(row);
                _this3.$refs.packageModuleItemTask.init(row); // if(row.is_delay == 1){
                //   await this.$refs.addDelayTime.init()
                // }else{
                //   this.confirmPackage()
                // }


              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    confirmPackage: function confirmPackage() {
      var _this4 = this;

      this.$confirm('是否确认打包?', '确认', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var getData = JSON.parse(_this4.chooseItem);
        var params = {
          game_group_id: getData.game_group_id,
          original_package_type_id: getData.original_package_type_id,
          original_package_id: getData.original_package_id,
          is_delay: getData.is_delay,
          delay_time: _this4.delay_time / 1000,
          params: getData.params,
          icon: getData.icon,
          sdkType: getData.sdkType,
          adv_sdk_url_ver: getData.adv_sdk_url_ver,
          advSdkType: getData.advSdkType,
          chooseStatus: getData.chooseStatus,
          app_id: getData.app_id,
          sdk_pem_type: getData.sdk_pem_type,
          report_check_item: getData.report_check_item
        };

        _this4.$api.operationAdd(params).then(function (res) {
          if (res.status == 200) {
            _this4.$api.operationStart({
              id: res.data.id
            }).then(function (res1) {
              if (res1.status == 200) {
                _this4.$message({
                  message: '操作成功',
                  type: 'success'
                });

                _this4.getList(_this4.paramsData.page);
              }
            });
          }
        });
      });
    },
    watchParams: function watchParams(data) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var copyData;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                copyData = JSON.parse(data.params);
                _context3.next = 3;
                return delete copyData.adv_config;

              case 3:
                _context3.next = 5;
                return delete copyData.key_store;

              case 5:
                _context3.next = 7;
                return delete copyData.platform_params;

              case 7:
                _context3.next = 9;
                return delete copyData.sdk_download_url;

              case 9:
                _this5.$refs.parameterAllDataPopup.init(JSON.stringify(copyData));

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }
};